/** @jsxImportSource @emotion/react */
import slugify from 'react-slugify'

import ArticleReferenceBlock from '@app/components/Guide/article/ArticleReferenceBlock'

import { ReferencesBlockType } from './types'

interface ReferencesBlockProps {
  block: ReferencesBlockType
}

export const ReferencesBlock = ({ block }: ReferencesBlockProps) => {
  return (
    <section className="space-y-2">
      {block.Title && (
        <h3
          id={slugify(block.Title)}
          className="scroll-mt-[70px] text-xl font-bold leading-[150%] tracking-[0.32px] text-foreground"
        >
          {block.Title}
        </h3>
      )}
      <ArticleReferenceBlock id={block.id} Label={block.Label} Url={block.Url} />
    </section>
  )
}

export default ReferencesBlock
